import React from 'react'

export function PizzaIllustration({ size = 140 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 140 140" style={{ display: 'block' }}>
      <defs>
        <radialGradient id="crust" cx="50%" cy="60%" r="50%">
          <stop offset="0%" stopColor="#d4943a" />
          <stop offset="100%" stopColor="#a06420" />
        </radialGradient>
        <radialGradient id="sauce" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#c0392b" />
          <stop offset="100%" stopColor="#922b21" />
        </radialGradient>
        <radialGradient id="cheese" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#f9e79f" />
          <stop offset="100%" stopColor="#f0c040" />
        </radialGradient>
      </defs>
      {/* Crust */}
      <ellipse cx="70" cy="78" rx="58" ry="52" fill="url(#crust)" />
      {/* Sauce */}
      <ellipse cx="70" cy="76" rx="50" ry="44" fill="url(#sauce)" />
      {/* Cheese blobs */}
      <ellipse cx="70" cy="72" rx="38" ry="32" fill="url(#cheese)" opacity="0.9" />
      <ellipse cx="56" cy="68" rx="12" ry="10" fill="#f9e79f" opacity="0.7" />
      <ellipse cx="84" cy="76" rx="10" ry="9" fill="#f9e79f" opacity="0.7" />
      <ellipse cx="68" cy="84" rx="9" ry="8" fill="#f9e79f" opacity="0.6" />
      {/* Toppings - pepperoni */}
      <circle cx="64" cy="64" r="7" fill="#8b1a1a" opacity="0.85" />
      <circle cx="80" cy="68" r="6" fill="#8b1a1a" opacity="0.85" />
      <circle cx="60" cy="80" r="6" fill="#8b1a1a" opacity="0.85" />
      {/* Basil leaves */}
      <ellipse cx="72" cy="58" rx="5" ry="3" fill="#27ae60" opacity="0.9" transform="rotate(-20,72,58)" />
      <ellipse cx="76" cy="60" rx="4" ry="2.5" fill="#2ecc71" opacity="0.8" transform="rotate(10,76,60)" />
      {/* Highlight */}
      <ellipse cx="55" cy="58" rx="12" ry="6" fill="white" opacity="0.08" />
    </svg>
  )
}

export function CookiesIllustration({ size = 140 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 140 140" style={{ display: 'block' }}>
      <defs>
        <radialGradient id="cookie1" cx="40%" cy="40%" r="55%">
          <stop offset="0%" stopColor="#d4a56a" />
          <stop offset="100%" stopColor="#a0713a" />
        </radialGradient>
        <radialGradient id="cookie2" cx="40%" cy="40%" r="55%">
          <stop offset="0%" stopColor="#c8954a" />
          <stop offset="100%" stopColor="#8a5e28" />
        </radialGradient>
      </defs>
      {/* Back cookie */}
      <circle cx="80" cy="72" r="38" fill="url(#cookie2)" />
      {/* Chocolate chips - back */}
      <ellipse cx="72" cy="62" rx="4" ry="3.5" fill="#3d1f00" opacity="0.8" />
      <ellipse cx="88" cy="68" rx="3.5" ry="3" fill="#3d1f00" opacity="0.8" />
      <ellipse cx="80" cy="80" rx="4" ry="3.5" fill="#3d1f00" opacity="0.8" />
      <ellipse cx="68" cy="78" rx="3" ry="2.5" fill="#3d1f00" opacity="0.7" />
      <ellipse cx="90" cy="78" rx="3" ry="2.5" fill="#3d1f00" opacity="0.7" />
      {/* Front cookie */}
      <circle cx="60" cy="78" r="38" fill="url(#cookie1)" />
      {/* Chocolate chips - front */}
      <ellipse cx="52" cy="68" rx="4" ry="3.5" fill="#3d1f00" opacity="0.85" />
      <ellipse cx="68" cy="72" rx="3.5" ry="3" fill="#3d1f00" opacity="0.85" />
      <ellipse cx="58" cy="84" rx="4" ry="3.5" fill="#3d1f00" opacity="0.85" />
      <ellipse cx="46" cy="82" rx="3" ry="2.5" fill="#3d1f00" opacity="0.75" />
      <ellipse cx="70" cy="86" rx="3" ry="2.5" fill="#3d1f00" opacity="0.75" />
      {/* Highlight */}
      <circle cx="48" cy="66" r="10" fill="white" opacity="0.1" />
      {/* Crumbs */}
      <circle cx="94" cy="96" r="3" fill="#a0713a" opacity="0.6" />
      <circle cx="88" cy="102" r="2" fill="#c8954a" opacity="0.5" />
      <circle cx="100" cy="102" r="2.5" fill="#a0713a" opacity="0.5" />
    </svg>
  )
}

export function SoupIllustration({ size = 140 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 140 140" style={{ display: 'block' }}>
      <defs>
        <linearGradient id="bowl" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#e8d5b7" />
          <stop offset="100%" stopColor="#c4a882" />
        </linearGradient>
        <radialGradient id="broth" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#e8a830" />
          <stop offset="100%" stopColor="#b87820" />
        </radialGradient>
      </defs>
      {/* Bowl */}
      <path d="M 20 70 Q 20 108 70 112 Q 120 108 120 70 Z" fill="url(#bowl)" />
      {/* Broth */}
      <ellipse cx="70" cy="70" rx="48" ry="14" fill="url(#broth)" />
      {/* Noodles */}
      <path d="M 38 70 Q 50 62 60 70 Q 70 78 80 70 Q 90 62 100 70" stroke="#f0e0a0" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M 35 74 Q 48 66 58 74 Q 68 82 78 74 Q 88 66 100 74" stroke="#e8d490" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.7" />
      {/* Carrot slice */}
      <ellipse cx="55" cy="68" rx="7" ry="5" fill="#e67e22" />
      <line x1="55" y1="63" x2="55" y2="73" stroke="#c0612a" strokeWidth="1" />
      <line x1="50" y1="68" x2="60" y2="68" stroke="#c0612a" strokeWidth="1" />
      {/* Herb */}
      <circle cx="84" cy="68" r="4" fill="#27ae60" opacity="0.85" />
      {/* Bowl rim */}
      <ellipse cx="70" cy="70" rx="50" ry="15" fill="none" stroke="#a89070" strokeWidth="2" />
      {/* Steam wisps */}
      <path d="M 52 54 Q 48 44 52 36" stroke="#cccccc" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
      <path d="M 70 50 Q 66 40 70 32" stroke="#cccccc" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.4" />
      <path d="M 88 54 Q 84 44 88 36" stroke="#cccccc" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
      {/* Spoon */}
      <ellipse cx="114" cy="80" rx="6" ry="4" fill="#d4c0a0" />
      <line x1="114" y1="84" x2="114" y2="110" stroke="#c0a880" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  )
}

export function FoodIllustration({ type, size }) {
  switch (type) {
    case 'pizza':   return <PizzaIllustration size={size} />
    case 'cookies': return <CookiesIllustration size={size} />
    case 'soup':    return <SoupIllustration size={size} />
    default:        return <PizzaIllustration size={size} />
  }
}
